import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//
// Pipe Modules
//
import { RtiPipeModule } from '../../../pipe/rti-pipe.module';
//
// Component
//
import { RtiHtml } from './rti-html';

@NgModule({
  imports: [
    CommonModule,
    RtiPipeModule
  ],
  declarations: [
    RtiHtml
  ],
  exports: [
    RtiHtml
  ]
})

export class RtiHtmlModule {
}
